import { Component, Input, OnInit } from '@angular/core';

import { Notification, NotificationType } from 'src/app/core/types/notifications';

@Component({
  selector: 'shared-notification',
  templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit {

  @Input('notification')
  public notification!: Notification;

  public hide: boolean = false;

  ngOnInit(): void {
    setTimeout(() => this.hide = true, this.notification?.duration - 400);
  }

  public get notificationStylesType(): string {
    switch (this.notification.type) {
      case NotificationType.success:
        return 'bg-green-100 border-green-500 text-green-900';
      case NotificationType.danger:
        return 'bg-red-100 border-red-500 text-red-900';
      case NotificationType.warning:
        return 'bg-orange-100 border-orange-500 text-orange-900';
      case NotificationType.info:
        return 'bg-cyan-100 border-cyan-500 text-cyan-900';
      default:
        return '';
    }
  }

  public get notificationIconType(): string {
    switch (this.notification.type) {
      case NotificationType.success:
        return 'text-green-500 fa-circle-check';
      case NotificationType.danger:
        return 'text-red-500 fa-circle-xmark';
      case NotificationType.warning:
        return 'text-orange-500 fa-triangle-exclamation';
      case NotificationType.info:
        return 'text-cyan-500 fa-circle-info';
      default:
        return '';
    }
  }
}